Promise.all([
  import('../../plugins/semantic/modal.scss'),
  import('../../plugins/semantic/modal'),
  import('./tab-current-deals.scss'),
]).then(() => {
  $('.widget.tab-current-deals').each(function (i, el) {
    $(el).data('widget', new TabCurrentDeals(el))
    $(el).data('widget').init()
  })
  
  // Additional debugging and emergency fallback for mobile
  if (process.env.NODE_ENV === 'development') {
    console.log('TabCurrentDeals widgets found:', $('.widget.tab-current-deals').length)
    $('.widget.tab-current-deals').each(function(i, el) {
      console.log('Widget', i, ':', el)
      console.log('Modal found in widget:', $(el).find('.terms-popup').length)
      console.log('Expander buttons found:', $(el).find('.expander').length)
    })
  }
  
  // Emergency global fallback that works regardless of widget initialization
  // Only handle expanders that are NOT in deals-widget (which has its own handler)
  $(document).off('click.emergency-terms').on('click.emergency-terms', '.expander', function(e) {
    // Skip if this is in a deals-widget - let deals-widget.js handle it
    if ($(this).closest('.deals-widget').length > 0) {
      console.log('Expander in deals-widget detected, letting deals-widget.js handle it')
      return
    }
    console.log('Any expander clicked:', this, 'Text:', $(this).text().trim())
    
    if ($(this).text().trim().includes('View Full Conditions')) {
      e.preventDefault()
      e.stopPropagation()
      
      console.log('Emergency fallback triggered for View Full Conditions button')
      
      const contentEl = $(this).siblings('.content').first()
      let modal = $(this).closest('.widget').find('.terms-popup')
      
      // If no modal in current widget, look for modal in parent deals-widget or any terms-popup
      if (!modal.length) {
        modal = $(this).closest('.deals-widget').find('.terms-popup')
      }
      if (!modal.length) {
        modal = $('.terms-popup').first()
      }
      
      if (modal.length && contentEl.length) {
        const contentHtml = contentEl.html()
        if (contentHtml && contentHtml.trim()) {
          console.log('Opening modal with content:', contentHtml.substring(0, 100) + '...')
          modal.find('.content').html(contentHtml)
          modal.modal('show')
        } else {
          console.warn('No content found for modal')
        }
      } else {
        console.error('Modal or content not found. Modal:', modal.length, 'Content:', contentEl.length)
      }
    }
  })
  
  // Even more aggressive - catch ANY button click that contains "View Full Conditions"
  $(document).off('click.super-emergency').on('click.super-emergency', 'button', function(e) {
    if ($(this).text().includes('View Full Conditions')) {
      // Skip if this is in a deals-widget - let deals-widget.js handle it
      if ($(this).closest('.deals-widget').length > 0) {
        console.log('Button in deals-widget detected, letting deals-widget.js handle it')
        return
      }
      console.log('SUPER EMERGENCY: View Full Conditions button clicked!', this)
      
      // Try to find any related modal and content
      const contentEl = $(this).siblings('.content').first()
      if (!contentEl.length) {
        console.log('No sibling .content found, looking for parent structure...')
        const parent = $(this).closest('.deal-conditions, .col, .terms')
        console.log('Parent found:', parent.length, parent.get(0))
        if (parent.length) {
          const parentContent = parent.find('.content').first()
          console.log('Content in parent:', parentContent.length, parentContent.html()?.substring(0, 100))
        }
      }
      
      // Try to find the real content first, then fall back to test content
      let contentHtml = $(this).siblings('.content').html()
      if (!contentHtml || contentHtml.trim() === '') {
        // Look for content in parent structure
        const parent = $(this).closest('.deal-conditions, .col, .terms')
        if (parent.length) {
          contentHtml = parent.find('.content').first().html()
        }
      }
      
      // Try to find modal in proper hierarchy first
      let anyModal = $(this).closest('.deals-widget').find('.terms-popup')
      if (!anyModal.length) {
        anyModal = $(this).closest('.widget').find('.terms-popup')
      }
      if (!anyModal.length) {
        anyModal = $('.terms-popup').first()
      }
      console.log('Terms-popup found:', anyModal.length, 'in hierarchy')
      if (anyModal.length) {
        // Use real content if found, otherwise use test content
        if (contentHtml && contentHtml.trim() !== '') {
          console.log('Loading real content into modal')
          anyModal.find('.content').html(contentHtml)
        } else {
          console.log('No real content found, using test content')
          anyModal.find('.content').html('<h2>Test Modal</h2><p>This modal is now at the highest z-index level.</p><p>If you see this, the z-index fix is working.</p>')
        }
        
        // Reset scroll position to top
        anyModal.find('.content').scrollTop(0)
        
        // Try multiple ways to show the modal
        try {
          // For mobile, manually trigger slide animation
          if (window.innerWidth <= 767) {
            console.log('Emergency handler: Mobile detected, using custom slide animation')
            
            // Use the same pattern as the working pet info modal
            // Step 1: Position modal off-screen with no transition
            anyModal.css({
              'display': 'flex',
              'transform': 'translateY(100%)',
              'transition': 'none'
            })
            anyModal.addClass('visible active')
            
            // Step 2: Force a reflow to ensure off-screen position is applied
            anyModal[0].offsetHeight
            
            // Step 3: Enable transition and slide up on next frame (same as pet modal)
            requestAnimationFrame(() => {
              anyModal.css({
                'transition': 'transform 0.3s ease',
                'transform': 'translateY(0)'
              })
              console.log('Emergency handler: Slide animation triggered - matching pet modal pattern')
            })
          } else {
            // Desktop - use normal Semantic UI modal
            anyModal.modal('show')
          }
          
          console.log('Modal show() called with z-index:', anyModal.css('z-index'))
          
          // Debug modal classes and transform for animation troubleshooting
          setTimeout(() => {
            console.log('Modal classes after show:', anyModal.attr('class'))
            console.log('Modal transform:', anyModal.css('transform'))
            console.log('Modal bottom:', anyModal.css('bottom'))
            console.log('Modal display:', anyModal.css('display'))
          }, 100)
          
        } catch (error) {
          console.error('Error calling modal show:', error)
          
          // Fallback: manually show the modal
          anyModal.addClass('visible active').show()
          console.log('Manual modal show attempted')
          
          // Debug fallback state
          setTimeout(() => {
            console.log('Fallback modal classes:', anyModal.attr('class'))
            console.log('Fallback modal transform:', anyModal.css('transform'))
          }, 100)
        }
      }
    }
  })
  
  // Add global debug function for manual testing
  window.debugTermsModal = function() {
    console.log('=== TERMS MODAL DEBUG ===')
    console.log('TabCurrentDeals widgets:', $('.widget.tab-current-deals').length)
    console.log('Terms popups found:', $('.terms-popup').length)
    console.log('Expander buttons found:', $('.expander').length)
    
    $('.expander').each(function(i, btn) {
      console.log(`Expander ${i}:`, btn, 'Text:', $(btn).text().trim())
    })
    
    // Try to manually trigger a modal
    const modal = $('.terms-popup').first()
    if (modal.length) {
      console.log('Attempting to manually open first terms popup...')
      
      // Try to find real content from any expander
      let realContent = null
      $('.expander').each(function() {
        const content = $(this).siblings('.content').html()
        if (content && content.trim() !== '') {
          realContent = content
          return false // break
        }
      })
      
      if (realContent) {
        console.log('Using real content from expander')
        modal.find('.content').html(realContent)
      } else {
        console.log('No real content found, using test content')
        modal.find('.content').html('<h2>Manual Test - High Z-Index</h2><p>If you see this above all other modals, the z-index fix is working.</p>')
      }
      
      // Reset scroll position to top
      modal.find('.content').scrollTop(0)
      
      // Use custom slide animation for mobile
      if (window.innerWidth <= 767) {
        console.log('Debug function: Mobile detected, using custom slide animation')
        
        // Use the same pattern as the working pet info modal
        // Step 1: Position modal off-screen with no transition
        modal.css({
          'display': 'flex',
          'transform': 'translateY(100%)',
          'transition': 'none'
        })
        modal.addClass('visible active')
        
        // Step 2: Force a reflow to ensure off-screen position is applied
        modal[0].offsetHeight
        
        // Step 3: Enable transition and slide up on next frame (same as pet modal)
        requestAnimationFrame(() => {
          modal.css({
            'transition': 'transform 0.3s ease',
            'transform': 'translateY(0)'
          })
          console.log('Debug function: Slide animation triggered - matching pet modal pattern')
        })
      } else {
        // Desktop - use normal Semantic UI modal
        modal.modal('show')
      }
    }
  }
  
  console.log('Debug function added: Call window.debugTermsModal() to test the modal manually')
  
  // Centralized close function to avoid code duplication
  window.closeTermsModal = function(modal) {
    if (window.innerWidth <= 767) {
      console.log('Closing terms modal: Mobile detected, using slide down animation')
      
      // Prevent multiple close attempts
      if (modal.hasClass('closing')) {
        console.log('Modal already closing, ignoring')
        return
      }
      modal.addClass('closing')
      
      // Ensure modal is visible before starting animation
      if (!modal.hasClass('visible')) {
        console.log('Modal not visible, hiding immediately')
        modal.removeClass('closing')
        return
      }
      
      // Slide down animation
      modal.css({
        'transition': 'transform 0.3s ease',
        'transform': 'translateY(100%)'
      })
      
      console.log('Close animation started, waiting 300ms...')
      
      // Hide modal and remove classes after animation
      setTimeout(() => {
        console.log('Animation complete, cleaning up modal')
        
        // Remove modal classes and hide
        modal.removeClass('visible active animating closing').hide()
        modal.css('display', 'none')
        
        // Explicitly remove Semantic UI dimmer
        $('.ui.dimmer.modals').removeClass('visible active').hide()
        $('body').removeClass('dimmable dimmed')
        
        console.log('Terms modal and dimmer hidden')
      }, 300)
    } else {
      // Desktop - use normal Semantic UI close
      console.log('Desktop detected, using Semantic UI close')
      modal.modal('hide')
    }
  }
  
  // Global close handler for terms modal close button
  $(document).on('click', '.terms-popup .icon-close', function(e) {
    e.preventDefault()
    e.stopPropagation()
    
    const modal = $(this).closest('.terms-popup')
    window.closeTermsModal(modal)
  })
  
  // Global close handler for clicking outside modal (dimmer)
  $(document).on('click', '.ui.dimmer.modals', function(e) {
    // Only close if clicking directly on the dimmer, not on modal content
    if (e.target === this) {
      const modal = $('.terms-popup.visible')
      if (modal.length) {
        window.closeTermsModal(modal)
      }
    }
  })
})

function TabCurrentDeals(el) {
  const self = this
  self.el = $(el)
  self.isLoaded = false
  self.dealTemplate = require('./tab-current-deals.hbs')

  self.render = function (data) {
    // Iterate over each deal in AvailableDeals to rewrite the url
    data.AvailableDeals.forEach(function (deal) {
      if (deal.CtaLabel == "Remove" && window.location.search.includes(deal.PromoCode) && deal.Restricted == true) {
        deal.Restricted = false;
      }
    });
    const html = self.dealTemplate(data)
    self.el.find('.results').html(html)

    // Append pages params to deals links as required
    var params = window.location.href.split('?')[1]
    if (!params) return
    self.el.find('.append-querystring').each(function (i, el) {
      let href = $(el).attr('href')
      // checking for any elemnts that have the Remove contexts for each element
      if ($(el)[0].textContent == 'Remove') {
        const url = window.location.href;
        const urlParams = new URLSearchParams(new URL(url).search);
        const dealCode = urlParams.get('dealCode');
        const propertyCode = urlParams.get('propertyCode');
        
        //.find(d => href.includes(d.PromoCode));
        let newUrl = "/deals/"+propertyCode+"/" + dealCode + "/remove" + window.location.search;
        $(el).attr('href', `${newUrl}`);
      }
      else {
        $(el).attr('href', `${href}?${params}`)
      }
  })
}

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TabCurrentDeals init', self)
    }
    self.el.css('opacity', 1)

    self.termsModal = self.el.find('.terms-popup').modal()
    
    // Debug: Log when modal is initialized
    if (process.env.NODE_ENV === 'development') {
      console.log('Terms modal initialized:', self.termsModal)
    }
    
    // Note: Close functionality is handled by global handlers to avoid conflicts
    
    // Primary event handler - scoped to widget
    self.el.on('click', '.expander', function (e) {
      e.preventDefault()
      e.stopPropagation()
      
      // Debug: Log when expander is clicked
      if (process.env.NODE_ENV === 'development') {
        console.log('Expander clicked:', this)
        console.log('Siblings content:', $(this).siblings('.content'))
        console.log('Content HTML:', $(this).siblings('.content').html())
      }
      
      const contentHtml = $(this).siblings('.content').html()
      if (contentHtml && contentHtml.trim() !== '') {
        self.termsModal.find('.content').html(contentHtml)
        
        // Reset scroll position to top
        self.termsModal.find('.content').scrollTop(0)
        
        // Use custom slide animation for mobile
        if (window.innerWidth <= 767) {
          console.log('Primary handler: Mobile detected, using custom slide animation')
          
          // Use the same pattern as the working pet info modal
          // Step 1: Position modal off-screen with no transition
          self.termsModal.css({
            'display': 'flex',
            'transform': 'translateY(100%)',
            'transition': 'none'
          })
          self.termsModal.addClass('visible active')
          
          // Step 2: Force a reflow to ensure off-screen position is applied
          self.termsModal[0].offsetHeight
          
          // Step 3: Enable transition and slide up on next frame (same as pet modal)
          requestAnimationFrame(() => {
            self.termsModal.css({
              'transition': 'transform 0.3s ease',
              'transform': 'translateY(0)'
            })
            console.log('Primary handler: Slide animation triggered - matching pet modal pattern')
          })
        } else {
          // Desktop - use normal Semantic UI modal
          self.termsModal.modal('show')
        }
      } else {
        console.warn('No content found for terms modal')
      }
    })
    
    // Fallback global event handler for tab-current-deals
    $(document).on('click', '.widget.tab-current-deals .expander', function (e) {
      e.preventDefault()
      e.stopPropagation()
      
      if (process.env.NODE_ENV === 'development') {
        console.log('Global expander fallback triggered:', this)
      }
      
      const widget = $(this).closest('.widget.tab-current-deals')
      const modal = widget.find('.terms-popup')
      const contentHtml = $(this).siblings('.content').html()
      
      if (modal.length && contentHtml && contentHtml.trim() !== '') {
        modal.find('.content').html(contentHtml)
        
        // Reset scroll position to top
        modal.find('.content').scrollTop(0)
        
        // Use custom slide animation for mobile
        if (window.innerWidth <= 767) {
          console.log('Fallback handler: Mobile detected, using custom slide animation')
          
          // Use the same pattern as the working pet info modal
          // Step 1: Position modal off-screen with no transition
          modal.css({
            'display': 'flex',
            'transform': 'translateY(100%)',
            'transition': 'none'
          })
          modal.addClass('visible active')
          
          // Step 2: Force a reflow to ensure off-screen position is applied
          modal[0].offsetHeight
          
          // Step 3: Enable transition and slide up on next frame (same as pet modal)
          requestAnimationFrame(() => {
            modal.css({
              'transition': 'transform 0.3s ease',
              'transform': 'translateY(0)'
            })
            console.log('Fallback handler: Slide animation triggered - matching pet modal pattern')
          })
        } else {
          // Desktop - use normal Semantic UI modal
          modal.modal('show')
        }
      }
    })


    $(document).on("click", ".tab-close-button", function(e) {
      e.preventDefault(); // Prevent the default action of the click event
      //Just using the pop up modules
      $('.icon-close').click();
  });


    window.dbs.globalEvents.subscribe('deals_updated', function (deals) {
      if(process.env.NODE_ENV === 'development') {
        console.log('TabCurrentDeals deals_updated event received', deals)
      }
      if (deals.AvailableDeals && deals.AvailableDeals.length) {
        self.render(deals)
        const name = self.el.parents('.tab-content').attr('data-tab')
        const checkCurrentDealsIsOpen =$('div.tab[data-tab="current-deals"]').hasClass('active');
        if (checkCurrentDealsIsOpen)
        {
          window.dbs.globalEvents.emit('reload_tab', name, true);
        }
      } else {
        // If there is no tab content to show, remove the tab from the page
        // Possibly remove deal here if there's no deals showing
        const name = self.el.parents('.tab-content').attr('data-tab')
        // This will remove deal tab completely instead of hiding it, to prevent first tab display bug
        self.el.parents('.park-summary-tabs').find(`.tab-container .tab[data-tab="${name}"]`).remove();
        // Also remove the corresponding mobile button from park-summary widget
        $('.widget.park-summary').find(`.mobile-tab-buttons .mobile-tab-button[data-tab="${name}"]`).remove();
        window.dbs.globalEvents.emit('remove_tab', name, true)
      }

      if (!self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
        self.isLoaded = true
      }
    })

    window.dbs.globalEvents.subscribe('was_tab_loaded', function () {
      if (self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      }
    })
  }
}
